import React, { useState } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import axios from "axios";

import { Header, StatsPanel, ReactTable } from "../components";
import routes from "../routes/routes";
import { withAuthHeader } from "../routes/authRequest";

const Events = () => {
    const { register, handleSubmit, errors } = useForm();
    const [message, setMessage] = useState("");
    const mutation = useMutation(eventData => withAuthHeader.post(routes.api.locations.addEvent, eventData))

    const header = [
        {
          Header: 'Column 1',
          accessor: 'col1', // accessor is the "key" in the data
        },
        {
          Header: 'Column 2',
          accessor: 'col2',
        },
      ]
   const data = [
    {
      col1: 'Hello',
      col2: 'World',
    },
    {
      col1: 'react-table',
      col2: 'rocks',
    },
    {
      col1: 'whatever',
      col2: 'you want',
    },
    {
      col1: 'whatever',
      col2: 'you want',
    },
    {
      col1: 'whatever',
      col2: 'you want',
    },
    {
      col1: 'whatever',
      col2: 'you want',
    },
  ]
    return (
        <div className="mainpanel">
            {/* <!-- pageheader --> */}
            <Header />

            <div className="contentpanel">
                {/* <div className="row row-stat">
                    <StatsPanel
                        icon="fa fa-dollar"
                        value="NGN 98,102,766"
                        yesterday="NGN 98,102,766"
                        color="panel-success-alt"
                        title="TOTAL EARNINGS"
                    />
                    <StatsPanel
                        icon="fa fa-users"
                        value="NGN 1,102,544"
                        yesterday="NGN 1,098,544"
                        color="panel-primary"
                        title="TODAY'S EARNINGS"
                    />
                    <StatsPanel
                        icon="fa fa-pencil"
                        value="3,102"
                        yesterday="3,101"
                        color="panel-dark"
                        title="TOTAL USERS"
                    />
                </div> */}
                {/* <!-- col-md-6 --> */}
                <div className="col-md-12">
                <h3>All Events</h3>
                    <ReactTable header={header} data={data}/>
                </div>
            </div>
        </div>
    );
};

export default Events;
